import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinnavimumbai() {



    const cardData = {




keyword: "Cab Service in Navi Mumbai",

headingDescription: "Shreesha Tours & Travels provides reliable, affordable, and comfortable Cab Services in Navi Mumbai for local travel, airport transfers, railway station pickup and drop, corporate transportation, one-way cabs, round-trip taxi services, sightseeing tours, and outstation journeys across Maharashtra and India. We offer chauffeur-driven Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles to suit every travel requirement. Whether you are traveling for business meetings, family vacations, pilgrimage tours, weekend getaways, corporate events, or long-distance travel, our experienced drivers and well-maintained fleet ensure a safe and hassle-free journey. With doorstep pickup anywhere in Navi Mumbai, transparent pricing, flexible booking options, online reservations, and 24/7 customer support, Shreesha Tours & Travels guarantees punctual, comfortable, and professional taxi services for every customer.",

topPlaces: [
  {
    title: "Navi Mumbai to Pune",
    description: "Pune is the most preferred outstation destination from Navi Mumbai for business travel, IT professionals, students, and family visits. Popular destinations include Hinjawadi, Baner, Kharadi, Magarpatta, Wakad, and Pimpri-Chinchwad."
  },
  {
    title: "Navi Mumbai to Lonavala",
    description: "Lonavala is a beautiful hill station known for Tiger Point, Bhushi Dam, Rajmachi Fort, Karla Caves, waterfalls, and lush green valleys. It is one of the most popular weekend getaway destinations from Navi Mumbai."
  },
  {
    title: "Navi Mumbai to Mahabaleshwar",
    description: "Mahabaleshwar is famous for Venna Lake, Arthur's Seat, strawberry farms, scenic viewpoints, and pleasant weather. It is a favorite destination for couples, families, and nature lovers."
  },
  {
    title: "Navi Mumbai to Shirdi",
    description: "Shirdi is one of India's most visited pilgrimage destinations, attracting devotees to the sacred Sai Baba Temple. Comfortable cab services make the religious journey convenient for families and senior citizens."
  },
  {
    title: "Navi Mumbai to Nashik",
    description: "Nashik is renowned for Trimbakeshwar Jyotirlinga, Panchavati, vineyards, temples, and business centers. It is an ideal destination for religious, leisure, and corporate travel."
  },
  {
    title: "Navi Mumbai to Goa",
    description: "Goa is India's leading beach destination, famous for its beautiful coastline, churches, forts, luxury resorts, nightlife, and water sports. Long-distance cab services provide a relaxing road trip from Navi Mumbai."
  },
  {
    title: "Navi Mumbai to Alibaug",
    description: "Alibaug is a popular coastal getaway offering beaches, sea forts, luxury resorts, water sports, and peaceful surroundings. It is perfect for weekend vacations and family outings."
  },
  {
    title: "Navi Mumbai to Surat",
    description: "Surat is a major commercial city known for its textile and diamond industries. Business professionals frequently travel between Navi Mumbai and Surat for meetings, exhibitions, and industrial visits."
  },
  {
    title: "Navi Mumbai to Ahmedabad",
    description: "Ahmedabad is Gujarat's commercial hub with leading industries, business parks, heritage attractions, and shopping destinations. It is a preferred destination for both corporate and leisure travelers."
  },
  {
    title: "Navi Mumbai to Indore",
    description: "Indore is Madhya Pradesh's commercial capital, popular for business travel, Rajwada Palace, Sarafa Food Market, and nearby religious destinations like Ujjain and Omkareshwar. It is one of the preferred long-distance cab routes from Navi Mumbai."
  }
],



"services": [
  {
    "name": "Cab Service in Navi Mumbai",
    "description": "Book Cab Service in Navi Mumbai for safe, comfortable, and reliable transportation with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova Crysta, SUV, Kia Carens, and Tempo Traveller options for local travel, airport transfers, business meetings, family trips, sightseeing, railway station pickups, hotel transfers, and outstation journeys with affordable pricing and 24x7 booking support."
  },
  {
    "name": "Taxi Service in Navi Mumbai",
    "description": "Choose Taxi Service in Navi Mumbai for fast, affordable, and dependable travel with experienced drivers and clean vehicles. Whether you need a local ride, airport pickup and drop, office commute, corporate transportation, family outing, or long-distance travel, our taxi service offers punctual pickups, transparent fares, and comfortable journeys throughout Navi Mumbai and beyond."
  },
  {
    "name": "Navi Mumbai Cab Booking",
    "description": "Complete Navi Mumbai Cab Booking with quick online reservations, instant confirmation, and multiple vehicle options to suit your travel needs. Book chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and premium cars for local travel, airport transfers, outstation trips, business visits, and sightseeing with convenient doorstep pickup."
  },
  {
    "name": "Navi Mumbai Taxi Service",
    "description": "Hire Navi Mumbai Taxi Service for reliable city and outstation transportation with professional chauffeurs and comfortable AC vehicles. Enjoy smooth travel for business meetings, shopping trips, railway station transfers, airport travel, family functions, and holiday tours with flexible booking options and competitive fares."
  },
  {
    "name": "Best Cab Service Navi Mumbai",
    "description": "Choose the Best Cab Service Navi Mumbai for premium travel with trained drivers, well-maintained vehicles, and exceptional customer support. Our cab service is ideal for airport transfers, office commuting, corporate travel, family vacations, local sightseeing, and long-distance journeys with transparent pricing and timely service."
  },
  {
    "name": "Navi Mumbai Car Rental Service",
    "description": "Book Navi Mumbai Car Rental Service for chauffeur-driven cars with flexible hourly, daily, and outstation rental packages. Select from Sedan, SUV, Innova Crysta, Kia Carens, and luxury vehicles for weddings, corporate events, family travel, business meetings, airport transfers, and tourist destinations."
  },
  {
    "name": "Navi Mumbai Outstation Cab",
    "description": "Reserve Navi Mumbai Outstation Cab for comfortable one way and round trip travel to destinations across Maharashtra, Goa, Gujarat, Karnataka, and other states. Enjoy spacious AC vehicles, experienced chauffeurs, transparent pricing, and reliable transportation for family holidays, business trips, and weekend getaways."
  },
  {
    "name": "Navi Mumbai Airport Taxi",
    "description": "Book Navi Mumbai Airport Taxi for timely airport pickup and drop services with professional chauffeurs and comfortable vehicles. Enjoy hassle-free transportation to and from Mumbai Airport with flight tracking, luggage assistance, doorstep pickup, affordable fares, and 24x7 availability for business and leisure travelers."
  },
  {
    "name": "Navi Mumbai One Way Cab",
    "description": "Choose Navi Mumbai One Way Cab for economical single-direction travel without paying return charges. Our one way cab service offers fixed pricing, experienced drivers, clean AC vehicles, and convenient pickup options for airport transfers, city-to-city travel, business visits, and personal journeys."
  },
  {
    "name": "Navi Mumbai Round Trip Taxi",
    "description": "Book Navi Mumbai Round Trip Taxi for comfortable return journeys with customized travel packages and flexible schedules. Perfect for family vacations, corporate travel, religious tours, sightseeing, weekend trips, and long-distance travel with reliable chauffeur-driven vehicles and affordable round trip fares."
  },
  {
    "name": "Navi Mumbai Corporate Cab Service",
    "description": "Choose Navi Mumbai Corporate Cab Service for executive transportation, employee travel, airport transfers, office commuting, and business meetings. Our professional chauffeurs, premium vehicles, monthly rental packages, and punctual service provide reliable transportation solutions for companies and corporate clients."
  },
  {
    "name": "Navi Mumbai Local Taxi Service",
    "description": "Hire Navi Mumbai Local Taxi Service for quick and convenient travel within the city with experienced drivers and comfortable AC cars. Ideal for shopping, medical visits, office travel, school pickups, hotel transfers, railway station transportation, and daily commuting with flexible booking options."
  },
  {
    "name": "Navi Mumbai 24x7 Cab Service",
    "description": "Book Navi Mumbai 24x7 Cab Service for round-the-clock transportation with reliable drivers and well-maintained vehicles available anytime. Whether you require late-night airport transfers, emergency travel, early morning pickups, business transportation, local rides, or outstation journeys, our 24-hour cab service ensures safe, comfortable, and punctual travel."
  }
],
"tableData": [
  ["Cab Service in Navi Mumbai", "Taxi Service in Navi Mumbai"],
  ["Navi Mumbai Cab Booking", "Navi Mumbai Taxi Service"],
  ["Best Cab Service Navi Mumbai", "Navi Mumbai Car Rental Service"],
  ["Navi Mumbai Outstation Cab", "Navi Mumbai Airport Taxi"],
  ["Navi Mumbai One Way Cab", "Navi Mumbai Round Trip Taxi"],
  ["Navi Mumbai Corporate Cab Service", "Navi Mumbai Local Taxi Service"],
  ["Navi Mumbai 24x7 Cab Service", ""]
],




whychoose: [
  {
    WhyChooseheading: "Your Everyday Travel Partner in Navi Mumbai",
    WhyChoosedescription: "Whether you're commuting for work, catching a flight, planning a family outing, or heading to another city, Shreesha Travels provides dependable cab services in Navi Mumbai with a focus on comfort, punctuality, and convenience."
  },
  {
    WhyChooseheading: "Ideal for Daily, Weekend & Long-Distance Travel",
    WhyChoosedescription: "From short city rides to extended outstation journeys, our taxi service is suitable for business travel, personal trips, educational tours, holiday vacations, and special occasions throughout the year."
  },
  {
    WhyChooseheading: "Choose the Right Vehicle for Your Journey",
    WhyChoosedescription: "Our fleet includes Hatchbacks, Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Luxury Cars, Tempo Travellers, and Mini Buses, offering travel solutions for individuals, families, and large groups."
  },
  {
    WhyChooseheading: "Convenient Airport & Railway Station Transfers",
    WhyChoosedescription: "Book reliable cabs from Navi Mumbai to Mumbai Airport, railway stations, hotels, business parks, and nearby cities with timely pickup and hassle-free transportation."
  },
  {
    WhyChooseheading: "Travel Across Maharashtra & Beyond",
    WhyChoosedescription: "Our outstation taxi service connects Navi Mumbai with destinations such as Pune, Lonavala, Mahabaleshwar, Nashik, Shirdi, Goa, Surat, Ahmedabad, Kolhapur, and many other cities across India."
  },
  {
    WhyChooseheading: "Customized Travel Plans for Every Requirement",
    WhyChoosedescription: "Choose from one-way taxis, round-trip cabs, full-day rentals, corporate transportation, sightseeing tours, wedding travel, or multi-day travel packages based on your itinerary."
  },
  {
    WhyChooseheading: "Safe Journeys with Experienced Chauffeurs",
    WhyChoosedescription: "Our professional drivers are familiar with Navi Mumbai, Mumbai, expressways, and major highways, ensuring a smooth, safe, and enjoyable travel experience."
  },
  {
    WhyChooseheading: "Experience Reliable Service with Shreesha Travels",
    WhyChoosedescription: "With transparent pricing, responsive booking assistance, and a commitment to customer satisfaction, we make every journey from Navi Mumbai comfortable and worry-free."
  }
]

};

const faqData = [
  {
    question: "Which areas in Navi Mumbai do you provide cab services?",
    answer: "Our cab service covers all major areas including Vashi, Nerul, Belapur, Kharghar, Airoli, Ghansoli, Koparkhairane, Sanpada, Panvel, Kamothe, Kalamboli, Taloja, and surrounding locations."
  },
  {
    question: "Can I hire a cab from Navi Mumbai for a multi-day trip?",
    answer: "Yes, we provide customized taxi packages for multi-day business tours, family vacations, pilgrimages, and long-distance travel."
  },
  {
    question: "Which car is recommended for a family of six?",
    answer: "For six passengers, Innova, Innova Crysta, Ertiga, SUVs, and Tempo Travellers are comfortable options depending on luggage requirements."
  },
  {
    question: "Do you provide taxi services for weddings and special events?",
    answer: "Yes, we arrange transportation for weddings, receptions, engagements, family functions, and other special occasions."
  },
  {
    question: "Can I schedule a cab early in the morning or late at night?",
    answer: "Yes, advance bookings are available for early morning departures, late-night arrivals, and scheduled travel."
  },
  {
    question: "Are corporate travel packages available from Navi Mumbai?",
    answer: "Yes, businesses can book taxis for employee transportation, executive travel, conferences, client visits, and corporate events."
  },
  {
    question: "Do you offer one-way as well as return taxi services?",
    answer: "Yes, you can choose one-way travel, round-trip bookings, hourly rentals, or customized travel plans."
  },
  {
    question: "Can I request multiple pickup or drop locations?",
    answer: "Yes, multi-stop itineraries can be arranged depending on your travel plan and route."
  },
  {
    question: "How is the taxi fare determined?",
    answer: "The fare depends on the selected vehicle, total distance, travel duration, route, waiting time, and the type of booking."
  },
  {
    question: "How do I reserve a cab in Navi Mumbai with Shreesha Travels?",
    answer: "Simply share your pickup location, destination, travel date, passenger count, and preferred vehicle to receive a personalized quotation and instant booking assistance."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Harsh Vora",
    feedback: "Excellent coordination from the booking team made the entire journey effortless. The cab reached on schedule, the ride was smooth, and every detail was handled professionally.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Nandini Kulkarni",
    feedback: "A comfortable vehicle, courteous chauffeur, and seamless travel experience made this one of the most pleasant outstation journeys. Shreesha Travels delivered exactly what was promised.",
    rating: 5
  }
];














    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Navi Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/cab-service-in-navi-mumbai.webp",
  "description":
    "Book Cab Service in Navi Mumbai with Shreesha Tours & Travels for safe, comfortable, and affordable local and outstation taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for airport transfers, corporate travel, business meetings, family trips, city rides, sightseeing tours, and intercity journeys with experienced chauffeurs.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/cab-service-in-navi-mumbai"
  }
};







    return (
        <div>
<Helmet>
  <title>Cab Service in Navi Mumbai | 24x7 Taxi Booking | +91 8355835813</title>

  <meta
    name="description"
    content="Book Cab Service in Navi Mumbai with Shreesha Travels for reliable local, airport, and outstation taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta with affordable fares, professional drivers, and 24x7 online booking."
  />

  <meta
    name="keywords"
    content="Cab Service in Navi Mumbai, Taxi Service in Navi Mumbai, Navi Mumbai Cab Booking, Navi Mumbai Taxi Service, Best Cab Service Navi Mumbai, Navi Mumbai Car Rental Service, Navi Mumbai Outstation Cab, Navi Mumbai Airport Cab, Online Cab Booking Navi Mumbai, Navi Mumbai One Way Cab, Navi Mumbai Round Trip Taxi, Navi Mumbai Taxi Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/45.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinnavimumbai;